<div [formGroup]="form" class="pt-2" fxLayout="row" fxLayoutAlign="space-between center">
    <mat-form-field fxFlex="1 1 48%">
        <mat-select placeholder="{{translate.getLng('PRODUCER')}}"
            formControlName="selectedManufacturer">
            <mat-option (click)="getPanelList(m.name, false)" *ngFor="let m of manufacturersList" [value]="m.name">
                {{m.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field fxFlex="1 1 48%">
        <mat-select placeholder="{{translate.getLng('SELECT_PANEL')}}"
            formControlName="selectedPanelID">
            <mat-option (click)="getPanelDetail(p.id)" *ngFor="let p of panelList" [value]="p.id"><img class="icon"
                    src="{{p.stock?.iconURL}}"> {{p.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div fxLayout="row" fxLayoutAlign="space-between center" class="sen-panel-box">
    <table fxFlex="1 1 60%" class="w-100 table mb-0">
        <tr>
            <td class="sen-info-color-bg p-1 w-50"><b>{{translate.getLng('NAME')}}</b></td>
            <td class="p-1">{{selectedPanelListDetail?.name}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('WIDTH')}} / {{translate.getLng('HEIGHT')}}</b></td>
            <td class="p-1">{{selectedPanelListDetail?.width}} <span *ngIf="selectedPanelListDetail?.height">/</span>
                {{selectedPanelListDetail?.height}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('CELL_TECH')}}</b></td>
            <td class="p-1">{{cellType[selectedPanelListDetail?.type]}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('THICKNESS')}}</b></td>
            <td class="p-1">{{selectedPanelListDetail?.thickness}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('ICOEFF')}}</b></td>
            <td class="p-1">{{convertToLocalNumber(selectedPanelListDetail?.Icoeff)}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('VCOEFF')}}</b></td>
            <td class="p-1">{{convertToLocalNumber(selectedPanelListDetail?.Vcoeff)}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('IPM')}}</b></td>
            <td class="p-1">{{convertToLocalNumber(selectedPanelListDetail?.Ipm)}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('VPM')}}</b></td>
            <td class="p-1">{{convertToLocalNumber(selectedPanelListDetail?.Vpm)}}</td>
        </tr>

        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('VOC')}}</b></td>
            <td class="p-1">{{convertToLocalNumber(selectedPanelListDetail?.Voc)}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('VSYS')}}</b></td>
            <td class="p-1">{{selectedPanelListDetail?.Vsys}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('PDC')}}</b></td>
            <td class="p-1">{{selectedPanelListDetail?.Pdc}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('ISC')}}</b></td>
            <td class="p-1">{{convertToLocalNumber(selectedPanelListDetail?.Isc)}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('IREVERSE')}}</b></td>
            <td class="p-1">{{selectedPanelListDetail?.Ireverse}}</td>
        </tr>
        <tr>
            <td class="sen-info-color-bg p-1"><b>{{translate.getLng('LANDSCAPE')}}</b></td>
            <td class="p-1">{{selectedPanelListDetail?.landscape}}</td>
        </tr>
        <tr>
            <td class="p-0 pb-1" colspan="2">
                <mat-checkbox class="py-1" [(ngModel)]="projectPanel" (ngModelChange)="setUserPanelSelected()"
                    [disabled]="projectPanelDisable">
                </mat-checkbox> &nbsp; <b>{{translate.getLng('PROJECT_PANEL')}}</b>
                <mat-icon matTooltipClass="sen-snackbar-color"
                    matTooltip="{{translate.getLng('PROJECT_PANEL_MESSAGE')}}" class="sen-fs12 ml-2 sen-cursor-pointer"
                    color="primary">info</mat-icon>
            </td>
        </tr>
        <tfoot *ngIf="!action">
            <tr>
                <td class="p-2 sen-fs08" colspan="2">{{translate.getLng('PANEL_STATICS_INFO')}}</td>
            </tr>
        </tfoot>
    </table>
    <div fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1 40%">
        <div>
            <!-- Add senItemID display -->
            <div *ngIf="selectedPanelListDetail?.senItemID" class="mb-2 text-center">
                <span class="sen-info-color-bg p-1"><b>{{translate.getLng('ARTNO')}}: {{selectedPanelListDetail.senItemID}}</b></span>
            </div>

            <div><img src="{{selectedPanelListDetail?.imageURL}}"></div>

            <div class="ax_default ellipse" id="u385_div" align="center">
                <img class="img" src="{{selectedPanelListDetail?.stock?.iconURL}}" />
                <span class="text " id="u385_text">
                    {{selectedPanelListDetail?.stock?.text}}
                </span>
            </div>
        </div>
    </div>
</div>
